import { useCallback, useEffect, useMemo, useState } from 'react';

function getPreferredTheme() {
  const stored = window.localStorage.getItem('omniscope:theme');
  if (stored === 'light' || stored === 'dark') return stored;
  return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
}

export function useTheme() {
  const [theme, setTheme] = useState(() => getPreferredTheme());

  useEffect(() => {
    applyTheme(theme);
    window.localStorage.setItem('omniscope:theme', theme);
  }, [theme]);

  useEffect(() => {
    applyTheme(getPreferredTheme());
  }, []);

  const toggle = useCallback(() => setTheme((t) => (t === 'dark' ? 'light' : 'dark')), []);
  const label = useMemo(() => (theme === 'dark' ? 'Mode clair' : 'Mode sombre'), [theme]);

  return { theme, setTheme, toggle, label };
}

